import React from "react";
import { Button } from "antd";
import icons from "Common/Icons";
import { Link } from "react-router-dom";
import "./Appointment.scss";
import { CONSTANTS } from "utils/constant";
class PhiNotFilled extends React.Component {
    _baseClassName = "schedule-appointment-container";
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {

    }
    render() {
        return (
            <div className={this._baseClassName}>
                <div className="main-content">
                    <div className="phi-not-filled-content">
                        <div><img className="center-img" src={icons.info_blue}/></div>
                        <div className="center-text"> {CONSTANTS.PHI_CENTER_TEXT} </div>
                        <div >
                            <Link to="/logged-in-user/health-profile">
                                <Button > <img src={icons.arrow_icon} className="pad-left-10" />  {CONSTANTS.HEALTH_INFORMATION} </Button>
                                
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


export default PhiNotFilled;